import colors from '@rategravity/frontend/theme/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import React from 'react';
import MediaQuery from 'react-responsive';
import { muiTheme } from '../../shared/theme';
import { AnonHeader } from '../header';

const style = {
  container: {
    backgroundColor: colors.quarternary
  },
  desktop: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  mobile: {
    textAlign: 'center'
  },
  content: {
    backgroundColor: '#F9F9F9',
    flexGrow: 1,
    position: 'relative',
    minHeight: '100vh'
  },
  text: {
    padding: '1em 0 ',
    color: colors.primary
  }
};

const Content = ({ children }) => (
  <div style={style.container}>
    <MediaQuery maxWidth={719}>
      <div style={style.mobile}>{children}</div>
    </MediaQuery>
    <MediaQuery minWidth={720}>
      <div style={style.desktop}>{children}</div>
    </MediaQuery>
  </div>
);

export default ({ children }) => (
  <MuiThemeProvider muiTheme={muiTheme}>
    <div>
      <AnonHeader />
      <Content>
        <div style={style.content}>{children}</div>
      </Content>
    </div>
  </MuiThemeProvider>
);



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js